<div class="slideout-content">
    <!-- Modal to add new user starts-->
    <div class="modalsd modal-slide-in sdfade new-user-modal" id="modals-slide-in">
        <div class="modal-dialog">
            <form class="add-new-user modal-content pt-0" [formGroup]="brandModel">
                <button type="reset" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="toggleSidebar('create-brand-modal')">
                    ×
                </button>

                <div class="modal-header mb-1">
                    <h5 class="modal-title" id="exampleModalLabel">Model {{selectBrandModal ? 'Güncelle':'Ekle'
                        }}</h5>
                </div>
                <div class="modal-body flex-grow-1">
                    <div class="row">
                        <div class="col-12 mb-1">
                            <div class="form-group">
                                <label for="kindName">Marka</label>
                                <ng-select [items]="brands" bindLabel="brandName" formControlName="brandId"
                                    bindValue="id">
                                </ng-select>
                                <div *ngIf="brandModel.get('brandId').invalid">
                                    <small class="text-danger" *ngIf="brandModel.get('brandId').errors.required">Marka
                                        seç.</small>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="kindName">Model</label>
                                <input type="text" formControlName="brandModelName" class="form-control"
                                    placeholder="Model Giriniz." />
                                <div *ngIf="brandModel.get('brandModelName').invalid">
                                    <small class="text-danger"
                                        *ngIf="brandModel.get('brandModelName').errors.required">Model
                                        zorunludur.</small>
                                    <small class="text-danger"
                                        *ngIf="brandModel.get('brandModelName').errors.maxlength">Model
                                        en
                                        fazla 100 karakter olabilir.</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button type="submit" [disabled]="brandModel.invalid" class="btn btn-primary col-12 mb-1"
                        (click)="onSubmit()" rippleEffect>
                        Kaydet
                    </button>
                    <button type="reset" class="btn btn-outline-secondary col-12 mb-1"
                        (click)="toggleSidebar('create-brand-modal')" rippleEffect>
                        İptal
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>